import { Component } from '@angular/core';

@Component({
  selector: 'app-rmd-tracker-advisor',
  templateUrl: './rmd-tracker-advisor.component.html',
  styleUrls: ['./rmd-tracker-advisor.component.css']
})
export class RmdTrackerAdvisorComponent {

}
